{
  "aberation":["aberration"],
  "abilty":["ability"],
  "abondon":["abandon"],
  "abbout":["about"],
  "abotu":["about"],
  "abscence":["absence"],
  "aborigene":["aborigine"],
  "accidant":["accident"],
  "abreviate":["abbreviate"],
  "abreviation":["abbreviation"],
  "abritrary":["arbitrary"],
  "absail":["abseil"],
  "absense":["absence"],
  "absorbsion":["absorption"],
  "absorbtion":["absorption"],
  "abudance":["abundance"],
  "abundunt":["abundant"],
  "acadamy":["academy"],
  "acadmic":["academic"],
  "accademic":["academic"],
  "accademy":["academy"],
  "accelleration":["acceleration"],
  "accension":["accession", "ascension"],
  "acceptence":["acceptance"],
  "accessable":["accessible"],
  "acident":["accident"],
  "acclimitization":["acclimatization"],
  "accomadate":["accommodate"],
  "accomadating":["accommodating"],
  "accomadation":["accommodation"],
  "accomdate":["accommodate"],
  "accomodate":["accommodate"],
  "accomodating":["accommodating"],
  "accomodation":["accommodation"],
  "accompanyed":["accompanied"],
  "accordeon":["accordion"],
  "accordian":["accordion"],
  "accoring":["according"],
  "accoustic":["acoustic"],
  "accquainted":["acquainted"],
  "accrediation":["accreditation"],
  "accredidation":["accreditation"],
  "accross":["across"],
  "acedemic":["academic"],
  "acheive":["achieve"],
  "acheivement":["achievement"],
  "acheivment":["achievement"],
  "achievment":["achievement"],
  "achive":["achieve", "archive"],
  "achivement":["achievement"],
  "acknowldeged":["acknowledged"],
  "ackward":["awkward", "backward"],
  "acommodate":["accommodate"],
  "acomplish":["accomplish"],
  "acomplished":["accomplished"],
  "acomplishment":["accomplishment"],
  "acording":["according"],
  "acquaintence":["acquaintance"],
  "acquiantence":["acquaintance"],
  "acquited":["acquitted"],
  "activites":["activities"],
  "acuracy":["accuracy"],
  "acustom":["accustom"],
  "acustommed":["accustomed"],
  "adbandon":["abandon"],
  "addional":["additional"],
  "additonal":["additional"],
  "addmission":["admission"],
  "addopt":["adopt"],
  "addres":["address"],
  "addresable":["addressable"],
  "addresed":["addressed"],
  "addtion":["addition"],
  "addtional":["additional"],
  "adecuate":["adequate"],
  "adequit":["adequate"],
  "adherance":["adherence"],
  "admendment":["amendment"],
  "admininistrative":["administrative"],
  "adminstrate":["administrate"],
  "adminstration":["administration"],
  "adminstrative":["administrative"],
  "adminstrator":["administrator"],
  "admissability":["admissibility"],
  "admissable":["admissible"],
  "admited":["admitted"],
  "adn":["and"],
  "adolecent":["adolescent"],
  "adquire":["acquire"],
  "adres":["address"],
  "adresable":["addressable"],
  "adress":["address"],
  "adressable":["addressable"],
  "adressed":["addressed"],
  "adressing":["dressing"],
  "adventrous":["adventurous"],
  "advertisment":["advertisement"],
  "advesary":["adversary"],
  "adviced":["advised"],
  "aeriel":["aerial"],
  "afair":["affair"],
  "afficionado":["aficionado"],
  "affilate":["affiliate"],
  "affilliate":["affiliate"],
  "affort":["afford", "effort"],
  "aforememtioned":["aforementioned"],
  "againnst":["against"],
  "agains":["against"],
  "agaisnt":["against"],
  "aganist":["against"],
  "aggreement":["agreement"],
  "aggregious":["egregious"],
  "aggresive":["aggressive"],
  "agian":["again"],
  "agianst":["against"],
  "agin":["again"],
  "agina":["again", "angina"],
  "aginst":["against"],
  "agravate":["aggravate"],
  "agre":["agree"],
  "agreeement":["agreement"],
  "agreemnt":["agreement"],
  "agregate":["aggregate"],
  "agreing":["agreeing"],
  "agression":["aggression"],
  "agressive":["aggressive"],
  "agressor":["aggressor"],
  "agricultue":["agriculture"],
  "agriculure":["agriculture"],
  "agricuture":["agriculture"],
  "ahev":["have"],
  "ahppen":["happen"],
  "ahve":["have"],
  "aicraft":["aircraft"],
  "aiport":["airport"],
  "airbourne":["airborne"],
  "aircaft":["aircraft"],
  "aircrafts":["aircraft"],
  "airrcraft":["aircraft"],
  "albiet":["albeit"],
  "alchohol":["alcohol"],
  "alchoholic":["alcoholic"],
  "alchol":["alcohol"],
  "alcholic":["alcoholic"],
  "alcohal":["alcohol"],
  "alcoholical":["alcoholic"],
  "aledge":["allege"],
  "aledged":["alleged"],
  "alege":["allege"],
  "aleged":["alleged"],
  "alegience":["allegiance"],
  "algebraical":["algebraic"],
  "algoritm":["algorithm"],
  "alledge":["allege"],
  "alledged":["alleged"],
  "allegence":["allegiance"],
  "allegience":["allegiance"],
  "allign":["align"],
  "alligned":["aligned"],
  "alliviate":["alleviate"],
  "allready":["already"],
  "allthough":["although"],
  "alltogether":["altogether"],
  "almsot":["almost"],
  "alochol":["alcohol"],
  "alomst":["almost"],
  "alot":["allot"],
  "alotted":["allotted"],
  "alreayd":["already"],
  "alse":["else"],
  "alsot":["also"],
  "altho":["although"],
  "althought":["although"],
  "altough":["although"],
  "alusion":["allusion", "illusion"],
  "alwasy":["always"],
  "alwyas":["always"],
  "amatuer":["amateur"],
  "amature":["armature", "amateur"],
  "amendmant":["amendment"],
  "Amercia":["America"],
  "amerliorate":["ameliorate"],
  "amke":["make"],
  "amking":["making"],
  "ammend":["amend"],
  "ammendment":["amendment"],
  "ammount":["amount"],
  "amoung":["among"],
  "amung":["among"],
  "amunition":["ammunition"],
  "analagous":["analogous"],
  "analitic":["analytic"],
  "analogeous":["analogous"],
  "anarchim":["anarchism"],
  "anarchistm":["anarchism"],
  "anbd":["and"],
  "ancestory":["ancestry"],
  "ancilliary":["ancillary"],
  "andd":["and"],
  "androgenous":["androgynous"],
  "androgeny":["androgyny"],
  "anihilation":["annihilation"],
  "aniversary":["anniversary"],
  "annoint":["anoint"],
  "annouced":["announced"],
  "annuled":["annulled"],
  "anohter":["another"],
  "anomolous":["anomalous"],
  "anomoly":["anomaly"],
  "anonimity":["anonymity"],
  "anounced":["announced"],
  "anouncement":["announcement"],
  "ansalization":["nasalization"],
  "antartic":["antarctic"],
  "anthropolgist":["anthropologist"],
  "anthropolgy":["anthropology"],
  "anual":["annual"],
  "anulled":["annulled"],
  "anwsered":["answered"],
  "anyhwere":["anywhere"],
  "anytying":["anything"],
  "aparent":["apparent"],
  "aparment":["apartment"],
  "apenines":["Apennines"],
  "aplication":["application"],
  "apon":["upon", "apron"],
  "apparant":["apparent"],
  "appart":["apart"],
  "appartment":["apartment"],
  "appealling":["appealing", "appalling"],
  "appeareance":["appearance"],
  "appearence":["appearance"],
  "appenines":["Apennines"],
  "apperance":["appearance"],
  "appereance":["appearance"],
  "applicaiton":["application"],
  "appintment":["appointment"],
  "appointmeent":["appointment"],
  "appointmentn":["appointment"],
  "appointemnt":["appointment"],
  "appology":["apology"],
  "apprearance":["appearance"],
  "apprieciate":["appreciate"],
  "appropiate":["appropriate"],
  "appropraite":["appropriate"],
  "appropropiate":["appropriate"],
  "approproximate":["approximate"],
  "aprehensive":["apprehensive"],
  "apropriate":["appropriate"],
  "aproval":["approval"],
  "aproximate":["approximate"],
  "aquaduct":["aqueduct"],
  "aquaintance":["acquaintance"],
  "aquainted":["acquainted"],
  "aquiantance":["acquaintance"],
  "aquire":["acquire"],
  "aquisition":["acquisition"],
  "aquitted":["acquitted"],
  "arangement":["arrangement"],
  "arbitarily":["arbitrarily"],
  "arbitary":["arbitrary"],
  "archaelogical":["archaeological"],
  "archaelogy":["archaeology"],
  "archaoelogy":["archaeology"],
  "archaology":["archaeology"],
  "archeaologist":["archaeologist"],
  "archetect":["architect"],
  "archetectural":["architectural"],
  "archetecture":["architecture"],
  "archiac":["archaic"],
  "archictect":["architect"],
  "architecht":["architect"],
  "architechture":["architecture"],
  "architectual":["architectural"],
  "archtype":["archetype"],
  "aready":["already"],
  "areodynamics":["aerodynamics"],
  "argubly":["arguably"],
  "arguement":["argument"],
  "arised":["arose"],
  "arival":["arrival"],
  "armamant":["armament"],
  "armistace":["armistice"],
  "arogant":["arrogant"],
  "arogent":["arrogant"],
  "aroud":["around"],
  "arrangment":["arrangement"],
  "arrengement":["arrangement"],
  "arround":["around"],
  "artcile":["article"],
  "artical":["article"],
  "artice":["article"],
  "articel":["article"],
  "artifical":["artificial"],
  "artillary":["artillery"],
  "arund":["around"],
  "asetic":["ascetic"],
  "asign":["assign"],
  "aslo":["also"],
  "asphyxation":["asphyxiation"],
  "assasin":["assassin"],
  "assasinate":["assassinate"],
  "assasination":["assassination"],
  "assassintation":["assassination"],
  "assemple":["assemble"],
  "assertation":["assertion"],
  "asside":["aside"],
  "assisnate":["assassinate"],
  "assit":["assist"],
  "assitant":["assistant"],
  "assocation":["association"],
  "assoicate":["associate"],
  "assosication":["assassination"],
  "assualt":["assault"],
  "assymetric":["asymmetric"],
  "assymetrical":["asymmetrical"],
  "asteriod":["asteroid"],
  "asthetic":["aesthetic"],
  "asthetically":["aesthetically"],
  "asume":["assume"],
  "atain":["attain"],
  "atheistical":["atheistic"],
  "athiesm":["atheism"],
  "athiest":["atheist"],
  "atorney":["attorney"],
  "atribute":["attribute"],
  "atributed":["attributed"],
  "attaindre":["attainder"],
  "attemp":["attempt"],
  "attemt":["attempt"],
  "attendence":["attendance"],
  "attendent":["attendant"],
  "attened":["attended"],
  "attension":["attention"],
  "attitide":["attitude"],
  "attributred":["attributed"],
  "audeince":["audience"],
  "austrailia":["Australia"],
  "austrailian":["Australian"],
  "auther":["author"],
  "authobiographic":["autobiographic"],
  "authobiography":["autobiography"],
  "authorative":["authoritative"],
  "authorithy":["authority"],
  "authoritive":["authoritative"],
  "automaticly":["automatically"],
  "automibile":["automobile"],
  "automonomous":["autonomous"],
  "autor":["author"],
  "autority":["authority"],
  "auxilary":["auxiliary"],
  "auxillary":["auxiliary"],
  "auxilliary":["auxiliary"],
  "availabe":["available"],
  "availablity":["availability"],
  "availaible":["available"],
  "availble":["available"],
  "availiable":["available"],
  "availible":["available"],
  "avalable":["available"],
  "avalance":["avalanche"],
  "avaliable":["available"],
  "avation":["aviation"],
  "avilable":["available"],
  "awya":["away"],
  "baceause":["because"],
  "backgorund":["background"],
  "bakc":["back"],
  "bandwith":["bandwidth"],
  "bankrupcy":["bankruptcy"],
  "banruptcy":["bankruptcy"],
  "baout":["about", "bout"],
  "basicaly":["basically"],
  "basicly":["basically"],
  "bcak":["back"],
  "beachead":["beachhead"],
  "beacuse":["because"],
  "beastiality":["bestiality"],
  "beatiful":["beautiful"],
  "beaurocracy":["bureaucracy"],
  "beaurocratic":["bureaucratic"],
  "beautyfull":["beautiful"],
  "becamae":["became"],
  "becames":["became"],
  "becasue":["because"],
  "beccause":["because"],
  "becomeing":["becoming"],
  "becomming":["becoming"],
  "becouse":["because"],
  "becuase":["because"],
  "bedore":["before"],
  "beeing":["being"],
  "befoer":["before"],
  "beggin":["begin", "begging"],
  "begginer":["beginner"],
  "beggining":["beginning"],
  "begining":["beginning"],
  "beginnig":["beginning"],
  "behavour":["behavior"],
  "beleif":["belief"],
  "beleive":["believe"],
  "beleiving":["believing"],
  "belive":["believe"],
  "belived":["beloved"],
  "belives":["beliefs"],
  "belligerant":["belligerent"],
  "bellweather":["bellwether"],
  "bemusemnt":["bemusement"],
  "beneficary":["beneficiary"],
  "beng":["being"],
  "benificial":["beneficial"],
  "benifit":["benefit"],
  "Bernouilli":["Bernoulli"],
  "beseige":["besiege"],
  "beteen":["between"],
  "betwen":["between"],
  "beween":["between"],
  "bewteen":["between"],
  "bigining":["beginning"],
  "biginning":["beginning"],
  "billingualism":["bilingualism"],
  "binominal":["binomial"],
  "bizzare":["bizarre"],
  "blaim":["blame"],
  "blessure":["blessing"],
  "Blitzkreig":["Blitzkrieg"],
  "boaut":["bout", "boat", "about"],
  "bodydbuilder":["bodybuilder"],
  "bombardement":["bombardment"],
  "bombarment":["bombardment"],
  "bondary":["boundary"],
  "boook":["book"],
  "borke":["broke"],
  "boundry":["boundary"],
  "bouyancy":["buoyancy"],
  "bouyant":["buoyant"],
  "boyant":["buoyant"],
  "bradcast":["broadcast"],
  "Brasillian":["Brazilian"],
  "breakthough":["breakthrough"],
  "breakthroughts":["breakthroughs"],
  "breif":["brief"],
  "breifly":["briefly"],
  "brethen":["brethren"],
  "bretheren":["brethren"],
  "briliant":["brilliant"],
  "brillant":["brilliant"],
  "brimestone":["brimstone"],
  "Britian":["Britain"],
  "Brittish":["British"],
  "broacasted":["broadcast"],
  "broadacasting":["broadcasting"],
  "Buddah":["Buddha"],
  "Buddist":["Buddhist"],
  "buisness":["business"],
  "buisnessman":["businessman"],
  "buoancy":["buoyancy"],
  "buring":["during"],
  "busines":["business"],
  "busineses":["business"],
  "busness":["business"],
  "bussiness":["business"],
  "caculater":["calculator"],
  "calaber":["caliber"],
  "calander":["calendar", "colander"],
  "calculater":["calculator"],
  "calculs":["calculus"],
  "caligraphy":["calligraphy"],
  "caluclate":["calculate"],
  "caluclated":["calculated"],
  "caluculate":["calculate"],
  "caluculated":["calculated"],
  "calulate":["calculate"],
  "calulated":["calculated"],
  "calulater":["calculator"],
  "Cambrige":["Cambridge"],
  "camoflage":["camouflage"],
  "campagin":["campaign"],
  "campain":["campaign"],
  "candadate":["candidate"],
  "candiate":["candidate"],
  "candidiate":["candidate"],
  "cannister":["canister"],
  "cannnot":["cannot"],
  "cannonical":["canonical"],
  "caost":["coast"],
  "caperbility":["capability"],
  "capible":["capable"],
  "captial":["capital"],
  "carachter":["character"],
  "carcas":["carcass", "Caracas"],
  "carefull":["careful"],
  "careing":["caring"],
  "carismatic":["charismatic"],
  "Carnagie":["Carnegie"],
  "carnege":["carnage", "Carnegie"],
  "carnige":["carnage", "Carnegie"],
  "Carnigie":["Carnegie"],
  "carniverous":["carnivorous"],
  "carreer":["career"],
  "Carribbean":["Caribbean"],
  "Carribean":["Caribbean"],
  "cartdridge":["cartridge"],
  "Carthagian":["Carthaginian"],
  "carthographer":["cartographer"],
  "cartilege":["cartilage"],
  "cartilidge":["cartilage"],
  "cartrige":["cartridge"],
  "casette":["cassette"],
  "casion":["caisson"],
  "cassawory":["cassowary"],
  "cassowarry":["cassowary"],
  "casue":["cause"],
  "casulaty":["casualty"],
  "catagory":["category"],
  "Cataline":["Catiline", "Catalina"],
  "catapillar":["caterpillar"],
  "catapiller":["caterpillar"],
  "catepillar":["caterpillar"],
  "catergorize":["categorize"],
  "caterpilar":["caterpillar"],
  "caterpiller":["caterpillar"],
  "cathlic":["catholic"],
  "catterpilar":["caterpillar"],
  "catterpillar":["caterpillar"],
  "cattleship":["battleship"],
  "Ceasar":["Caesar"],
  "Celcius":["Celsius"],
  "cementary":["cemetery"],
  "cemetarey":["cemetery"],
  "cemetary":["cemetery"],
  "cencus":["census"],
  "censur":["censor", "censure"],
  "cententenial":["centennial"],
  "centruy":["century"],
  "centuty":["century"],
  "ceratin":["certain", "keratin"],
  "cerimonial":["ceremonial"],
  "cerimonious":["ceremonious"],
  "cerimony":["ceremony"],
  "ceromony":["ceremony"],
  "certainity":["certainty"],
  "certian":["certain"],
  "cervial":["cervical", "servile"],
  "challange":["challenge"],
  "challanged":["challenged"],
  "challege":["challenge"],
  "Champange":["Champagne"],
  "changable":["changeable"],
  "charachter":["character"],
  "charactersistic":["characteristic"],
  "charactor":["character"],
  "charasmatic":["charismatic"],
  "chariman":["chairman"],
  "chasr":["chaser", "chase"],
  "cheif":["chief"],
  "chemcial":["chemical"],
  "chemestry":["chemistry"],
  "childbird":["childbirth"],
  "childen":["children"],
  "choosen":["chosen"],
  "chracter":["character"],
  "chuch":["church"],
  "Cincinatti":["Cincinnati"],
  "Cincinnatti":["Cincinnati"],
  "circulaton":["circulation"],
  "circumsicion":["circumcision"],
  "circut":["circuit"],
  "ciricuit":["circuit"],
  "ciriculum":["curriculum"],
  "civillian":["civilian"],
  "claer":["clear"],
  "clas":["class"],
  "clasic":["classic"],
  "clasical":["classical"],
  "cleareance":["clearance"],
  "clera":["clear"],
  "clincial":["clinical"],
  "cmo":["com"],
  "cmoputer":["computer"],
  "coctail":["cocktail"],
  "coform":["conform"],
  "cognizent":["cognizant"],
  "colateral":["collateral"],
  "colelctive":["collective"],
  "collaberative":["collaborative"],
  "collecton":["collection"],
  "collegue":["colleague"],
  "collonade":["colonnade"],
  "collony":["colony"],
  "collosal":["colossal"],
  "comander":["commander", "commandeer"],
  "comando":["commando"],
  "comany":["company"],
  "comapany":["company"],
  "comback":["comeback"],
  "combusion":["combustion"],
  "comdemnation":["condemnation"],
  "comemoretion":["commemoration"],
  "comision":["commission"],
  "comisioner":["commissioner"],
  "comission":["commission"],
  "comissioner":["commissioner"],
  "comited":["committed"],
  "comiting":["committing"],
  "comitted":["committed"],
  "comittee":["committee"],
  "comitting":["committing"],
  "commedic":["comedic"],
  "commemmorate":["commemorate"],
  "commerical":["commercial"],
  "commericial":["commercial"],
  "comming":["coming"],
  "comminication":["communication"],
  "commision":["commission"],
  "commisioner":["commissioner"],
  "commited":["committed"],
  "commitee":["committee"],
  "commiting":["committing"],
  "committe":["committee"],
  "committment":["commitment"],
  "commonweath":["commonwealth"],
  "communciation":["communication"],
  "communiation":["communication"],
  "compability":["compatibility"],
  "comparision":["comparison"],
  "comparitive":["comparative"],
  "compatability":["compatibility"],
  "compatable":["compatible"],
  "compatablity":["compatibility"],
  "compatiable":["compatible"],
  "compatiblity":["compatibility"],
  "compensantion":["compensation"],
  "competance":["competence"],
  "competant":["competent"],
  "competative":["competitive"],
  "competion":["competition", "completion"],
  "competitiion":["competition"],
  "competive":["competitive"],
  "competiveness":["competitiveness"],
  "comphrehensive":["comprehensive"],
  "compitent":["competent"],
  "completetion":["completion"],
  "complier":["compiler"],
  "componant":["component"],
  "comprable":["comparable"],
  "comprimise":["compromise"],
  "compulsary":["compulsory"],
  "compulsery":["compulsory"],
  "concensus":["consensus"],
  "concider":["consider"],
  "concidered":["considered"],
  "concieted":["conceited"],
  "concious":["conscious"],
  "conciousness":["consciousness"],
  "condidtion":["condition"],
  "conected":["connected"],
  "conection":["connection"],
  "conesencus":["consensus"],
  "confidental":["confidential"],
  "confortable":["comfortable"],
  "congresional":["congressional"],
  "conjecutre":["conjecture"],
  "Conneticut":["Connecticut"],
  "conquerd":["conquered"],
  "conquerer":["conqueror"],
  "conqured":["conquered"],
  "conscent":["consent"],
  "consciouness":["consciousness"],
  "consdider":["consider"],
  "consdidered":["considered"],
  "consdiered":["considered"],
  "consectutive":["consecutive"],
  "consentrate":["concentrate"],
  "consept":["concept"],
  "consern":["concern"],
  "conserned":["concerned"],
  "conserning":["concerning"],
  "conservitive":["conservative"],
  "consiciousness":["consciousness"],
  "consicousness":["consciousness"],
  "considerd":["considered"],
  "consideres":["considered"],
  "consious":["conscious"],
  "consistant":["consistent"],
  "consituency":["constituency"],
  "consitution":["constitution"],
  "consitutional":["constitutional"],
  "consolodate":["consolidate"],
  "consolodated":["consolidated"],
  "consonent":["consonant"],
  "consorcium":["consortium"],
  "conspiriator":["conspirator"],
  "constarnation":["consternation"],
  "constatn":["constant"],
  "constituant":["constituent"],
  "constituion":["constitution"],
  "constituional":["constitutional"],
  "consttruction":["construction"],
  "constuction":["construction"],
  "contstruction":["construction"],
  "consulant":["consultant"],
  "consumate":["consummate"],
  "consumated":["consummated"],
  "contaiminate":["contaminate"],
  "contemporaneus":["contemporaneous"],
  "contendor":["contender"],
  "contian":["contain"],
  "contibute":["contribute"],
  "contigent":["contingent"],
  "continential":["continental"],
  "continous":["continuous"],
  "contravercial":["controversial"],
  "contraversy":["controversy"],
  "contributer":["contributor"],
  "controled":["controlled"],
  "controling":["controlling"],
  "controll":["control"],
  "controvercial":["controversial"],
  "controvercy":["controversy"],
  "controversal":["controversial"],
  "controversey":["controversy"],
  "controvertial":["controversial"],
  "controvery":["controversy"],
  "contruction":["construction"],
  "conveinent":["convenient"],
  "convenant":["covenant"],
  "convential":["conventional"],
  "conviced":["convinced"],
  "convienient":["convenient"],
  "coordiantion":["coordination"],
  "coorperation":["cooperation", "corporation"],
  "coputer":["computer"],
  "copywrite":["copyright"],
  "coridal":["cordial"],
  "cornmitted":["committed"],
  "corosion":["corrosion"],
  "corparate":["corporate"],
  "correponding":["corresponding"],
  "correposding":["corresponding"],
  "correspondant":["correspondent"],
  "corrispond":["correspond"],
  "corrispondant":["correspondent"],
  "corrisponding":["corresponding"],
  "costitution":["constitution"],
  "coucil":["council"],
  "coudl":["could", "cloud"],
  "councellor":["counselor", "councilor"],
  "coururier":["courier", "couturier"],
  "coverted":["converted"],
  "cpoy":["coy", "copy"],
  "creedence":["credence"],
  "critereon":["criterion"],
  "criterias":["criteria"],
  "critisism":["criticism"],
  "critisize":["criticize"],
  "crowm":["crown"],
  "crtical":["critical"],
  "crucifiction":["crucifixion"],
  "cumulatative":["cumulative"],
  "curch":["church"],
  "curcuit":["circuit"],
  "curriculem":["curriculum"],
  "cxan":["cyan"],
  "cyclinder":["cylinder"],
  "dacquiri":["daiquiri"],
  "daed":["dead"],
  "dael":["deal", "dial"],
  "dalmation":["dalmatian"],
  "damenor":["demeanor"],
  "dammage":["damage"],
  "Dardenelles":["Dardanelles"],
  "daugher":["daughter"],
  "decendant":["descendant"],
  "decendent":["descendant"],
  "decideable":["decidable"],
  "decison":["decision"],
  "decribe":["describe"],
  "dectect":["detect"],
  "defendent":["defendant"],
  "deffine":["define"],
  "deffined":["defined"],
  "definate":["definite"],
  "definit":["definite"],
  "definiton":["definition"],
  "defintion":["definition"],
  "degrate":["degrade"],
  "delapidated":["dilapidated"],
  "delerious":["delirious"],
  "delevopment":["development"],
  "demenor":["demeanor"],
  "demographical":["demographic"],
  "demolision":["demolition"],
  "demorcracy":["democracy"],
  "demostration":["demonstration"],
  "deparment":["department"],
  "deparmental":["departmental"],
  "dependance":["dependence"],
  "dependancy":["dependency"],
  "dependant":["dependent"],
  "deram":["dram", "dream"],
  "derivitive":["derivative"],
  "derogitory":["derogatory"],
  "descision":["decision"],
  "descisions":["decisions"],
  "descripton":["description"],
  "desctruction":["destruction"],
  "deside":["decide"],
  "desktiop":["desktop"],
  "desorder":["disorder"],
  "desparate":["desperate", "disparate"],
  "despict":["depict"],
  "despiration":["desperation"],
  "destory":["destroy"],
  "deteriate":["deteriorate"],
  "detremental":["detrimental"],
  "develope":["develop"],
  "developement":["development"],
  "developped":["developed"],
  "develpment":["development"],
  "devestating":["devastating"],
  "devide":["divide"],
  "devided":["divided"],
  "devistating":["devastating"],
  "devolopement":["development"],
  "diablical":["diabolical"],
  "dichtomy":["dichotomy"],
  "dicover":["discover"],
  "dicovered":["discovered"],
  "dicovery":["discovery"],
  "didnt":["didn't"],
  "diea":["idea", "die"],
  "dieing":["dying", "dyeing"],
  "diety":["deity"],
  "diferent":["different"],
  "diferrent":["different"],
  "differnt":["different"],
  "difficulity":["difficulty"],
  "diffrent":["different"],
  "dificulty":["difficulty"],
  "dimention":["dimension"],
  "dimentional":["dimensional"],
  "dimesnional":["dimensional"],
  "diminuitive":["diminutive"],
  "dimunitive":["diminutive"],
  "diosese":["diocese"],
  "diphtong":["diphthong"],
  "diplomancy":["diplomacy"],
  "dipthong":["diphthong"],
  "directoty":["directory"],
  "disapointing":["disappointing"],
  "disasterous":["disastrous"],
  "disatrous":["disastrous"],
  "discribe":["describe"],
  "disctinction":["distinction"],
  "disctinctive":["distinctive"],
  "disemination":["dissemination"],
  "disiplined":["disciplined"],
  "disolved":["dissolved"],
  "disover":["discover"],
  "dispair":["despair"],
  "dispence":["dispense"],
  "dispicable":["despicable"],
  "dispite":["despite"],
  "dispostion":["disposition"],
  "distiction":["distinction"],
  "distingish":["distinguish"],
  "distingished":["distinguished"],
  "distingquished":["distinguished"],
  "distrubution":["distribution"],
  "distruction":["destruction"],
  "distructive":["destructive"],
  "ditributed":["distributed"],
  "diversed":["diverse"],
  "divinition":["divination"],
  "divison":["division"],
  "dum":["dumb"],
  "doccument":["document"],
  "doccumented":["documented"],
  "documenatry":["documentary"],
  "doens":["does"],
  "doesnt":["doesn't"],
  "doign":["doing"],
  "dominaton":["domination"],
  "dominent":["dominant"],
  "dominiant":["dominant"],
  "donig":["doing"],
  "dosen't":["doesn't"],
  "doub":["doubt", "daub"],
  "doulbe":["double"],
  "dramtic":["dramatic"],
  "Dravadian":["Dravidian"],
  "driectly":["directly"],
  "drnik":["drink"],
  "druming":["drumming"],
  "dupicate":["duplicate"],
  "durig":["during"],
  "durring":["during"],
  "duting":["during"],
  "eahc":["each"],
  "earnt":["earned"],
  "ecclectic":["eclectic"],
  "eceonomy":["economy"],
  "ecidious":["deciduous"],
  "eclispe":["eclipse"],
  "ecomonic":["economic"],
  "ect":["etc"],
  "eearly":["early"],
  "efel":["evil"],
  "effeciency":["efficiency"],
  "effecient":["efficient"],
  "efficency":["efficiency"],
  "efficent":["efficient"],
  "efford":["effort", "afford"],
  "effulence":["effluence"],
  "eigth":["eighth", "eight"],
  "eiter":["either"],
  "elction":["election"],
  "electic":["eclectic", "electric"],
  "electon":["election", "electron"],
  "electrial":["electrical"],
  "electricty":["electricity"],
  "elementay":["elementary"],
  "eletricity":["electricity"],
  "eligable":["eligible"],
  "elimentary":["elementary"],
  "elphant":["elephant"],
  "embarass":["embarrass"],
  "embarassed":["embarrassed"],
  "embarassing":["embarrassing"],
  "embarassment":["embarrassment"],
  "embargos":["embargoes"],
  "embarras":["embarrass"],
  "embarrased":["embarrassed"],
  "embarrasing":["embarrassing"],
  "embarrasment":["embarrassment"],
  "emblamatic":["emblematic"],
  "eminate":["emanate"],
  "emision":["emission"],
  "emited":["emitted"],
  "emiting":["emitting"],
  "emition":["emission", "emotion"],
  "emminent":["eminent", "imminent"],
  "emmisarry":["emissary"],
  "emmisary":["emissary"],
  "emmision":["emission"],
  "emmited":["emitted"],
  "emmiting":["emitting"],
  "emmitted":["emitted"],
  "emmitting":["emitting"],
  "emnity":["enmity"],
  "emperical":["empirical"],
  "emphsis":["emphasis"],
  "emphysyma":["emphysema"],
  "empirial":["empirical", "imperial"],
  "emporer":["emperor"],
  "enchancement":["enhancement"],
  "encouraing":["encouraging"],
  "encryptiion":["encryption"],
  "encylopedia":["encyclopedia"],
  "endig":["ending"],
  "enduce":["induce"],
  "ened":["need"],
  "engagment":["engagement"],
  "engeneer":["engineer"],
  "engeneering":["engineering"],
  "engieneer":["engineer"],
  "enlargment":["enlargement"],
  "Enlish":["English", "enlist"],
  "enourmous":["enormous"],
  "entaglements":["entanglements"],
  "enteratinment":["entertainment"],
  "enthusiatic":["enthusiastic"],
  "entitity":["entity"],
  "entrepeneur":["entrepreneur"],
  "enviorment":["environment"],
  "enviormental":["environmental"],
  "enviornment":["environment"],
  "enviornmental":["environmental"],
  "enviornmentalist":["environmentalist"],
  "enviroment":["environment"],
  "enviromental":["environmental"],
  "enviromentalist":["environmentalist"],
  "envolutionary":["evolutionary"],
  "enxt":["next"],
  "epsiode":["episode"],
  "equialent":["equivalent"],
  "equilibium":["equilibrium"],
  "equilibrum":["equilibrium"],
  "equiped":["equipped"],
  "equippment":["equipment"],
  "equitorial":["equatorial"],
  "equivelant":["equivalent"],
  "equivelent":["equivalent"],
  "equivilant":["equivalent"],
  "equivilent":["equivalent"],
  "equivlalent":["equivalent"],
  "eratic":["erratic"],
  "eratically":["erratically"],
  "eraticly":["erratically"],
  "esential":["essential"],
  "esle":["else"],
  "essencial":["essential"],
  "essense":["essence"],
  "essentail":["essential"],
  "essentialy":["essentially"],
  "essentual":["essential"],
  "essesital":["essential"],
  "ethnocentricm":["ethnocentrism"],
  "ethose":["those", "ethos"],
  "Europian":["European"],
  "Eurpean":["European"],
  "Eurpoean":["European"],
  "everthing":["everything"],
  "everyting":["everything"],
  "eveyr":["every"],
  "exagerate":["exaggerate"],
  "exagerated":["exaggerated"],
  "exagerrate":["exaggerate"],
  "exagerrated":["exaggerated"],
  "exampt":["exempt"],
  "exapansion":["expansion"],
  "excact":["exact"],
  "excange":["exchange"],
  "excecute":["execute"],
  "excecution":["execution"],
  "excelent":["excellent"],
  "excell":["excel"],
  "excellance":["excellence"],
  "excellant":["excellent"],
  "excercise":["exercise"],
  "exection":["execution"],
  "exelent":["excellent"],
  "exellent":["excellent"],
  "exemple":["example"],
  "exept":["except"],
  "exeptional":["exceptional"],
  "exerbate":["exacerbate"],
  "exerpt":["excerpt"],
  "exersize":["exercise"],
  "exerternal":["external"],
  "exhibtion":["exhibition"],
  "exibition":["exhibition"],
  "exicting":["exciting"],
  "exinct":["extinct"],
  "existance":["existence"],
  "existant":["existent"],
  "existince":["existence"],
  "exmaple":["example"],
  "exonorate":["exonerate"],
  "exoskelaton":["exoskeleton"],
  "expalin":["explain"],
  "expatriot":["expatriate"],
  "expeditonary":["expeditionary"],
  "expell":["expel"],
  "experiance":["experience"],
  "expierence":["experience"],
  "explaination":["explanation"],
  "exploititive":["exploitative"],
  "explotation":["exploitation"],
  "expropiation":["expropriation"],
  "exressed":["expressed"],
  "extention":["extension"],
  "extermist":["extremist"],
  "extint":["extinct", "extant"],
  "extradiction":["extradition"],
  "extraterrestial":["extraterrestrial"],
  "extravagent":["extravagant"],
  "extrordinarily":["extraordinarily"],
  "extrordinary":["extraordinary"],
  "eyar":["year"],
  "faciliate":["facilitate"],
  "facillitate":["facilitate"],
  "facist":["fascist"],
  "familliar":["familiar"],
  "famoust":["famous"],
  "fanatism":["fanaticism"],
  "Farenheit":["Fahrenheit"],
  "fatc":["fact"],
  "faught":["fought"],
  "feasable":["feasible"],
  "Febuary":["February"],
  "Feburary":["February"],
  "femminist":["feminist"],
  "feromone":["pheromone"],
  "fertily":["fertility"],
  "fianite":["finite"],
  "ficticious":["fictitious"],
  "fictious":["fictitious"],
  "fidn":["find"],
  "fiel":["feel", "field", "file", "phial"],
  "fightings":["fighting"],
  "filiament":["filament"],
  "finacial":["financial"],
  "firts":["first"],
  "flamable":["flammable"],
  "flawess":["flawless"],
  "Flemmish":["Flemish"],
  "flourescent":["fluorescent"],
  "flourine":["fluorine"],
  "fluorish":["flourish"],
  "follwoing":["following"],
  "folowing":["following"],
  "fomed":["formed"],
  "fomr":["from", "form"],
  "fonetic":["phonetic"],
  "foootball":["football"],
  "forbad":["forbade"],
  "forbiden":["forbidden"],
  "foreward":["foreword"],
  "forfiet":["forfeit"],
  "forhead":["forehead"],
  "foriegn":["foreign"],
  "Formalhaut":["Fomalhaut"],
  "formallize":["formalize"],
  "formaly":["formerly"],
  "formelly":["formerly"],
  "formidible":["formidable"],
  "formost":["foremost"],
  "forsaw":["foresaw"],
  "forseeable":["foreseeable"],
  "forunner":["forerunner"],
  "foucs":["focus"],
  "foudn":["found"],
  "fougth":["fought"],
  "foundary":["foundry"],
  "Foundland":["Newfoundland"],
  "fourty":["forty"],
  "fouth":["fourth"],
  "foward":["forward"],
  "Fransiscan":["Franciscan"],
  "freind":["friend"],
  "freindly":["friendly"],
  "frome":["from"],
  "fromed":["formed"],
  "froniter":["frontier"],
  "fucntion":["function"],
  "fufill":["fulfill"],
  "fufilled":["fulfilled"],
  "fulfiled":["fulfilled"],
  "fullfill":["fulfill"],
  "fullfilled":["fulfilled"],
  "fundametal":["fundamental"],
  "funguses":["fungi"],
  "funtion":["function"],
  "furuther":["further"],
  "futher":["further"],
  "futhermore":["furthermore"],
  "gae":["game", "Gael", "gale"],
  "galatic":["galactic"],
  "Galations":["Galatians"],
  "ganerate":["generate"],
  "ganster":["gangster"],
  "garantee":["guarantee"],
  "garnison":["garrison"],
  "gaurantee":["guarantee"],
  "gaurd":["guard", "gourd"],
  "gaurentee":["guarantee"],
  "geneological":["genealogical"],
  "geneology":["genealogy"],
  "genialia":["genitalia"],
  "geographicial":["geographical"],
  "geometrician":["geometer"],
  "gerat":["great"],
  "Ghandi":["Gandhi"],
  "glamourous":["glamorous"],
  "glight":["flight"],
  "godess":["goddess"],
  "Godounov":["Godunov"],
  "gogin":["going", "Gauguin"],
  "goign":["going"],
  "gonig":["going"],
  "gouvener":["governor"],
  "govement":["government"],
  "govenment":["government"],
  "govenrment":["government"],
  "goverance":["governance"],
  "goverment":["government"],
  "govermental":["governmental"],
  "governer":["governor"],
  "governmnet":["government"],
  "govorment":["government"],
  "govormental":["governmental"],
  "govornment":["government"],
  "gracefull":["graceful"],
  "graet":["great"],
  "grafitti":["graffiti"],
  "grammer":["grammar"],
  "grat":["great"],
  "gratuitious":["gratuitous"],
  "greatful":["grateful"],
  "greif":["grief"],
  "gropu":["group"],
  "grwo":["grow"],
  "Guaduloupe":["Guadalupe", "Guadeloupe"],
  "Guadulupe":["Guadalupe", "Guadeloupe"],
  "guage":["gauge"],
  "guarentee":["guarantee"],
  "Guatamala":["Guatemala"],
  "Guatamalan":["Guatemalan"],
  "guerrila":["guerrilla"],
  "guidence":["guidance"],
  "Guiness":["Guinness"],
  "Guiseppe":["Giuseppe"],
  "gunanine":["guanine"],
  "gurantee":["guarantee"],
  "guttaral":["guttural"],
  "gutteral":["guttural"],
  "haev":["have", "heave"],
  "halarious":["hilarious"],
  "Hallowean":["Halloween"],
  "halp":["help"],
  "hapen":["happen"],
  "hapening":["happening"],
  "harasment":["harassment"],
  "harassement":["harassment"],
  "harras":["harass"],
  "harrasment":["harassment"],
  "harrassment":["harassment"],
  "hasnt":["hasn't"],
  "Hatian":["Haitian"],
  "headquarer":["headquarter"],
  "headquater":["headquarter"],
  "headquaters":["headquarters"],
  "healthercare":["healthcare"],
  "heared":["heard"],
  "heathy":["healthy"],
  "Heidelburg":["Heidelberg"],
  "heirarchy":["hierarchy"],
  "helment":["helmet"],
  "helpfull":["helpful"],
  "hemmorhage":["hemorrhage"],
  "herad":["heard", "Hera"],
  "heridity":["heredity"],
  "heroe":["hero"],
  "heros":["heroes"],
  "hertiage":["heritage"],
  "hertzs":["hertz"],
  "hesistant":["hesitant"],
  "heterogenous":["heterogeneous"],
  "hieght":["height"],
  "hierachical":["hierarchical"],
  "hierachy":["hierarchy"],
  "hierarcical":["hierarchical"],
  "hierarcy":["hierarchy"],
  "hieroglph":["hieroglyph"],
  "hieroglphs":["hieroglyphs"],
  "higway":["highway"],
  "hillarious":["hilarious"],
  "himselv":["himself"],
  "hinderance":["hindrance"],
  "hinderence":["hindrance"],
  "hindrence":["hindrance"],
  "hipopotamus":["hippopotamus"],
  "hismelf":["himself"],
  "holf":["hold"],
  "holliday":["holiday"],
  "homogeneize":["homogenize"],
  "honory":["honorary"],
  "horrifing":["horrifying"],
  "hospitible":["hospitable"],
  "housr":["house"],
  "howver":["however"],
  "hstory":["history"],
  "hten":["then", "hen", "the"],
  "htere":["there", "here"],
  "htey":["they"],
  "htikn":["think"],
  "hting":["thing"],
  "htink":["think"],
  "htis":["this"],
  "humer":["humor"],
  "humerous":["humorous", "humerus"],
  "huminoid":["humanoid"],
  "humurous":["humorous"],
  "husban":["husband"],
  "hvae":["have"],
  "hvea":["have", "heave"],
  "hwihc":["which"],
  "hwile":["while"],
  "hwole":["whole"],
  "hydogen":["hydrogen"],
  "hydropobic":["hydrophobic"],
  "hygeine":["hygiene"],
  "hypocracy":["hypocrisy"],
  "hypocrasy":["hypocrisy"],
  "hypocricy":["hypocrisy"],
  "hypocrit":["hypocrite"],
  "iconclastic":["iconoclastic"],
  "idaeidae":["idea"],
  "idealogy":["ideology"],
  "identicial":["identical"],
  "ideosyncratic":["idiosyncratic"],
  "idesa":["ides"],
  "idiosyncracy":["idiosyncrasy"],
  "Ihaca":["Ithaca"],
  "illegimacy":["illegitimacy"],
  "illegitmate":["illegitimate"],
  "illess":["illness"],
  "illiegal":["illegal"],
  "illution":["illusion"],
  "ilness":["illness"],
  "ilogical":["illogical"],
  "imagenary":["imaginary"],
  "imagin":["imagine"],
  "imaginery":["imaginary", "imagery"],
  "imanent":["eminent", "imminent"],
  "imcomplete":["incomplete"],
  "imense":["immense"],
  "imigrant":["emigrant", "immigrant"],
  "imigration":["emigration", "immigration"],
  "iminent":["eminent", "imminent", "immanent"],
  "immitate":["imitate"],
  "immitator":["imitator"],
  "impecabbly":["impeccably"],
  "impedence":["impedance"],
  "impliment":["implement"],
  "implimented":["implemented"],
  "importamt":["important"],
  "impressario":["impresario"],
  "improvision":["improvisation"],
  "inadvertant":["inadvertent"],
  "inaguration":["inauguration"],
  "inappropiate":["inappropriate"],
  "inbalance":["imbalance"],
  "inbetween":["between"],
  "includ":["include"],
  "incompatability":["incompatibility"],
  "incompatablity":["incompatibility"],
  "incompatiblity":["incompatibility"],
  "incompetant":["incompetent"],
  "incomptetent":["incompetent"],
  "incoroporated":["incorporated"],
  "incorperation":["incorporation"],
  "incorportaed":["incorporated"],
  "inctroduce":["introduce"],
  "incunabla":["incunabula"],
  "indentical":["identical"],
  "indespensable":["indispensable"],
  "indespensible":["indispensable"],
  "indictement":["indictment"],
  "indigineous":["indigenous"],
  "indispensible":["indispensable"],
  "indulgue":["indulge"],
  "indutrial":["industrial"],
  "inevatible":["inevitable"],
  "inevitible":["inevitable"],
  "inevititably":["inevitably"],
  "infallable":["infallible"],
  "infectuous":["infectious"],
  "infered":["inferred"],
  "infinit":["infinite"],
  "inflamation":["inflammation"],
  "influencial":["influential"],
  "influented":["influenced"],
  "infomation":["information"],
  "informtion":["information"],
  "infrantryman":["infantryman"],
  "infrigement":["infringement"],
  "ingenius":["ingenious"],
  "inheritage":["heritage", "inheritance"],
  "inheritence":["inheritance"],
  "inital":["initial"],
  "initation":["initiation"],
  "initiaitive":["initiative"],
  "inmigrant":["immigrant"],
  "inocence":["innocence"],
  "inofficial":["unofficial"],
  "inpeach":["impeach"],
  "inpenetrable":["impenetrable"],
  "inpolite":["impolite"],
  "inprisonment":["imprisonment"],
  "insectiverous":["insectivorous"],
  "insensative":["insensitive"],
  "inseperable":["inseparable"],
  "insistance":["insistence"],
  "insitution":["institution"],
  "instade":["instead"],
  "instatance":["instance"],
  "institue":["institute"],
  "instuction":["instruction"],
  "insurence":["insurance"],
  "intelectual":["intellectual"],
  "inteligence":["intelligence"],
  "inteligent":["intelligent"],
  "intenational":["international"],
  "intented":["intended"],
  "intepretation":["interpretation"],
  "interational":["international"],
  "interbread":["interbreed", "interbred"],
  "interchangable":["interchangeable"],
  "interchangably":["interchangeably"],
  "intercontinential":["intercontinental"],
  "intercontinetal":["intercontinental"],
  "intered":["interred"],
  "intersted":["interested"],
  "interferance":["interference"],
  "intergration":["integration"],
  "interm":["interim"],
  "internation":["international"],
  "interpet":["interpret"],
  "interrim":["interim"],
  "interrugum":["interregnum"],
  "intertaining":["entertaining"],
  "interupt":["interrupt"],
  "intevene":["intervene"],
  "intial":["initial"],
  "intrest":["interest"],
  "intrument":["instrument"],
  "intrumental":["instrumental"],
  "intutive":["intuitive"],
  "inudstry":["industry"],
  "inumerable":["enumerable"],
  "inventer":["inventor"],
  "investingate":["investigate"],
  "involvment":["involvement"],
  "irelevent":["irrelevant"],
  "iresistable":["irresistible"],
  "iresistably":["irresistibly"],
  "iresistible":["irresistible"],
  "iresistibly":["irresistibly"],
  "iritable":["irritable"],
  "irrelevent":["irrelevant"],
  "irreplacable":["irreplaceable"],
  "irresistable":["irresistible"],
  "irresistably":["irresistibly"],
  "isnt":["isn't"],
  "iunior":["junior"],
  "iwll":["will"],
  "iwth":["with"],
  "Janurary":["January"],
  "Januray":["January"],
  "Japanes":["Japanese"],
  "jeapardy":["jeopardy"],
  "jorunal":["journal"],
  "Jospeh":["Joseph"],
  "jouney":["journey"],
  "jstu":["just"],
  "jsut":["just"],
  "Juadaism":["Judaism"],
  "Juadism":["Judaism"],
  "judical":["judicial"],
  "judisuary":["judiciary"],
  "juducial":["judicial"],
  "juristiction":["jurisdiction"],
  "kindergarden":["kindergarten"],
  "knifes":["knives"],
  "knive":["knife"],
  "knowlege":["knowledge"],
  "knowlegeable":["knowledgeable"],
  "knwo":["know"],
  "konw":["know"],
  "kwno":["know"],
  "labatory":["lavatory", "laboratory"],
  "labled":["labeled"],
  "labratory":["laboratory"],
  "laguage":["language"],
  "larg":["large"],
  "lastr":["last"],
  "lattitude":["latitude"],
  "launchs":["launch"],
  "lavae":["larvae"],
  "layed":["laid"],
  "lazyness":["laziness"],
  "leage":["league"],
  "leanr":["lean", "learn"],
  "leathal":["lethal"],
  "lefted":["left"],
  "legitamate":["legitimate"],
  "legitmate":["legitimate"],
  "lenght":["length"],
  "leran":["learn"],
  "leutenant":["lieutenant"],
  "levetate":["levitate"],
  "levle":["level"],
  "liasion":["liaison"],
  "liason":["liaison"],
  "libary":["library"],
  "libell":["libel"],
  "libguistic":["linguistic"],
  "libguistics":["linguistics"],
  "lible":["libel", "liable"],
  "lieing":["lying"],
  "liek":["like"],
  "liesure":["leisure"],
  "lieuenant":["lieutenant"],
  "liftime":["lifetime"],
  "likelyhood":["likelihood"],
  "liquify":["liquefy"],
  "liscense":["license"],
  "lisence":["license"],
  "lisense":["license"],
  "litature":["literature"],
  "literture":["literature"],
  "littel":["little"],
  "liuke":["like"],
  "livley":["lively"],
  "loev":["love"],
  "lonelyness":["loneliness"],
  "longitudonal":["longitudinal"],
  "lonley":["lonely"],
  "lonly":["lonely"],
  "loosing":["losing"],
  "lsat":["last"],
  "lveo":["love"],
  "lvoe":["love"],
  "Lybia":["Libya"],
  "maching":["machine", "matching"],
  "mackeral":["mackerel"],
  "magasine":["magazine"],
  "magizine":["magazine"],
  "magisine":["magazine"],
  "magincian":["magician"],
  "magnificient":["magnificent"],
  "magolia":["magnolia"],
  "maintainance":["maintenance"],
  "maintainence":["maintenance"],
  "maintance":["maintenance"],
  "maintenence":["maintenance"],
  "maintioned":["mentioned"],
  "majoroty":["majority"],
  "maked":["marked", "made"],
  "Malcom":["Malcolm"],
  "maltesian":["Maltese"],
  "mamal":["mammal"],
  "mamalian":["mammalian"],
  "managable":["manageable"],
  "managment":["management"],
  "manoeuverability":["maneuverability"],
  "manouver":["maneuver"],
  "manouverability":["maneuverability"],
  "manuever":["maneuver"],
  "manufature":["manufacture"],
  "manufaturing":["manufacturing"],
  "manuver":["maneuver"],
  "mariage":["marriage"],
  "marjority":["majority"],
  "marketting":["marketing"],
  "marmelade":["marmalade"],
  "marrage":["marriage"],
  "marraige":["marriage"],
  "marryied":["married"],
  "Massachussets":["Massachusetts"],
  "Massachussetts":["Massachusetts"],
  "masterbation":["masturbation"],
  "mataphysical":["metaphysical"],
  "materalists":["materialist"],
  "mathamatics":["mathematics"],
  "mathematican":["mathematician"],
  "mathematicas":["mathematics"],
  "mathmatician":["mathematician"],
  "mchanics":["mechanics"],
  "meaninng":["meaning"],
  "mear":["wear", "mere", "mare"],
  "mechandise":["merchandise"],
  "medacine":["medicine"],
  "medeival":["medieval"],
  "medevial":["medieval"],
  "medievel":["medieval"],
  "Mediteranean":["Mediterranean"],
  "memeber":["member"],
  "meranda":["veranda", "Miranda"],
  "mercentile":["mercantile"],
  "messanger":["messenger"],
  "metalic":["metallic"],
  "metalurgic":["metallurgic"],
  "metalurgical":["metallurgical"],
  "metalurgy":["metallurgy"],
  "metamorphysis":["metamorphosis"],
  "metaphoricial":["metaphorical"],
  "meterologist":["meteorologist"],
  "meterology":["meteorology"],
  "methaphor":["metaphor"],
  "Michagan":["Michigan"],
  "micoscopy":["microscopy"],
  "midwifes":["midwives"],
  "mileau":["milieu"],
  "milennium":["millennium"],
  "mileu":["milieu"],
  "miliary":["military"],
  "miligram":["milligram"],
  "milion":["million"],
  "miliraty":["military"],
  "millenial":["millennial"],
  "millenium":["millennium"],
  "millepede":["millipede"],
  "millioniare":["millionaire"],
  "millitary":["military"],
  "millon":["million"],
  "miltary":["military"],
  "minature":["miniature"],
  "minerial":["mineral"],
  "ministery":["ministry"],
  "minsitry":["ministry"],
  "minstry":["ministry"],
  "minumum":["minimum"],
  "miscelaneous":["miscellaneous"],
  "miscellanious":["miscellaneous"],
  "miscellanous":["miscellaneous"],
  "mischeivous":["mischievous"],
  "mischevious":["mischievous"],
  "mischievious":["mischievous"],
  "misdameanor":["misdemeanor"],
  "misdemenor":["misdemeanor"],
  "misile":["missile"],
  "Misouri":["Missouri"],
  "mispell":["misspell"],
  "mispelling":["misspelling"],
  "missen":["mizzen"],
  "Missisipi":["Mississippi"],
  "Missisippi":["Mississippi"],
  "missle":["missile"],
  "missonary":["missionary"],
  "misterious":["mysterious"],
  "mistery":["mystery"],
  "misteryous":["mysterious"],
  "mkae":["make"],
  "mkaing":["making"],
  "mkea":["make"],
  "moderm":["modem"],
  "modle":["model"],
  "moent":["moment"],
  "moeny":["money"],
  "momento":["memento"],
  "monestary":["monastery", "monetary"],
  "monolite":["monolithic"],
  "Monserrat":["Montserrat"],
  "montanous":["mountainous"],
  "Montnana":["Montana"],
  "monts":["months"],
  "moreso":["more"],
  "morgage":["mortgage"],
  "morrocco":["morocco"],
  "morroco":["morocco"],
  "mortage":["mortgage"],
  "mosture":["moisture"],
  "motiviated":["motivated"],
  "mounth":["month"],
  "movei":["movie"],
  "movment":["movement"],
  "mroe":["more"],
  "mucuous":["mucous"],
  "muder":["murder"],
  "multicultralism":["multiculturalism"],
  "muncipality":["municipality"],
  "munnicipality":["municipality"],
  "muscial":["musical"],
  "muscician":["musician"],
  "myraid":["myriad"],
  "mysef":["myself"],
  "mysogynist":["misogynist"],
  "mysogyny":["misogyny"],
  "mysterous":["mysterious"],
  "naieve":["naive"],
  "Naploeon":["Napoleon"],
  "Napolean":["Napoleon"],
  "Napoleonian":["Napoleonic"],
  "naturual":["natural"],
  "Nazereth":["Nazareth"],
  "neccesarily":["necessarily"],
  "neccesary":["necessary"],
  "neccessarily":["necessarily"],
  "neccessary":["necessary"],
  "necesarily":["necessarily"],
  "necesary":["necessary"],
  "necessiate":["necessitate"],
  "neglible":["negligible"],
  "negligable":["negligible"],
  "negociate":["negotiate"],
  "negociation":["negotiation"],
  "negociations":["negotiations"],
  "negotation":["negotiation"],
  "neice":["niece", "nice"],
  "neigborhood":["neighborhood"],
  "neigbour":["neighbor"],
  "neolitic":["neolithic"],
  "nessasarily":["necessarily"],
  "nessecary":["necessary"],
  "neverthless":["nevertheless"],
  "nightfa;;":["nightfall"],
  "nightime":["nighttime"],
  "nineth":["ninth"],
  "ninteenth":["nineteenth"],
  "ninty":["ninety"],
  "nkow":["know"],
  "nkwo":["know"],
  "nmae":["name"],
  "nonsence":["nonsense"],
  "nontheless":["nonetheless"],
  "norhern":["northern"],
  "northen":["northern"],
  "northereastern":["northeastern"],
  "notabley":["notably"],
  "noteable":["notable"],
  "noteably":["notably"],
  "noteriety":["notoriety"],
  "noth":["north"],
  "nothern":["northern"],
  "noticable":["noticeable"],
  "noticably":["noticeably"],
  "noticible":["noticeable"],
  "notwhithstanding":["notwithstanding"],
  "Novermber":["November"],
  "nowdays":["nowadays"],
  "nowe":["now"],
  "nto":["not"],
  "nucular":["nuclear"],
  "nuculear":["nuclear"],
  "nuisanse":["nuisance"],
  "numberous":["numerous"],
  "Nuremburg":["Nuremberg"],
  "nusance":["nuisance"],
  "nutritent":["nutrient"],
  "obediance":["obedience"],
  "obediant":["obedient"],
  "obession":["obsession"],
  "obstacal":["obstacle"],
  "obstruced":["obstructed"],
  "ocasion":["occasion"],
  "ocasional":["occasional"],
  "ocassion":["occasion"],
  "ocassional":["occasional"],
  "occaison":["occasion"],
  "occassion":["occasion"],
  "occassional":["occasional"],
  "occour":["occur"],
  "occurance":["occurrence"],
  "occured":["occurred"],
  "occurence":["occurrence"],
  "occuring":["occurring"],
  "occurr":["occur"],
  "occurrance":["occurrence"],
  "ocuntry":["country"],
  "ocurr":["occur"],
  "ocurrance":["occurrence"],
  "ocurred":["occurred"],
  "ocurrence":["occurrence"],
  "offical":["official"],
  "oftenly":["often"],
  "oging":["going"],
  "omision":["omission"],
  "omited":["omitted"],
  "omiting":["omitting"],
  "ommision":["omission"],
  "ommited":["omitted"],
  "ommiting":["omitting"],
  "ommitted":["omitted"],
  "ommitting":["omitting"],
  "omniverous":["omnivorous"],
  "omre":["more"],
  "onot":["note", "not"],
  "openess":["openness"],
  "oponent":["opponent"],
  "oportunity":["opportunity"],
  "opose":["oppose"],
  "oposite":["opposite"],
  "oposition":["opposition"],
  "oppinion":["opinion"],
  "opponant":["opponent"],
  "oppononent":["opponent"],
  "oppositition":["opposition"],
  "oppossed":["opposed"],
  "opprotunity":["opportunity"],
  "opression":["oppression"],
  "opressive":["oppressive"],
  "opthalmic":["ophthalmic"],
  "opthalmologist":["ophthalmologist"],
  "opthalmology":["ophthalmology"],
  "opthamologist":["ophthalmologist"],
  "optomism":["optimism"],
  "organim":["organism"],
  "organiztion":["organization"],
  "orgin":["origin", "organ"],
  "orginal":["original"],
  "oridinarily":["ordinarily"],
  "originall":["original"],
  "origional":["original"],
  "otehr":["other"],
  "oublisher":["publisher"],
  "ouevre":["oeuvre"],
  "oustanding":["outstanding"],
  "overwelming":["overwhelming"],
  "overwheliming":["overwhelming"],
  "owrk":["work"],
  "owudl":["would"],
  "oxigen":["oxygen"],
  "oximoron":["oxymoron"],
  "p0enis":["penis"],
  "paide":["paid"],
  "paitience":["patience"],
  "palce":["place", "palace"],
  "paleolitic":["paleolithic"],
  "paliamentarian":["parliamentarian"],
  "Palistian":["Palestinian"],
  "Palistinian":["Palestinian"],
  "pallete":["palette"],
  "pamflet":["pamphlet"],
  "pamplet":["pamphlet"],
  "pantomine":["pantomime"],
  "paralel":["parallel"],
  "paralell":["parallel"],
  "paranthesis":["parenthesis"],
  "paraphenalia":["paraphernalia"],
  "parisitic":["parasitic"],
  "parituclar":["particular"],
  "parliment":["parliament"],
  "parralel":["parallel"],
  "parrallel":["parallel"],
  "parrallell":["parallel"],
  "particualr":["particular"],
  "pary":["party"],
  "passerbys":["passersby"],
  "pasttime":["pastime"],
  "pastural":["pastoral"],
  "paticular":["particular"],
  "pavillion":["pavilion"],
  "pblisher":["publisher"],
  "pbulisher":["publisher"],
  "peageant":["pageant"],
  "peaple":["people"],
  "peculure":["peculiar"],
  "pedestrain":["pedestrian"],
  "peformed":["performed"],
  "peice":["piece"],
  "penatly":["penalty"],
  "penisula":["peninsula"],
  "penisular":["peninsular"],
  "penninsula":["peninsula"],
  "penninsular":["peninsular"],
  "pennisula":["peninsula"],
  "Pennyslvania":["Pennsylvania"],
  "pensle":["pencil"],
  "pensinula":["peninsula"],
  "peom":["poem"],
  "peopel":["people"],
  "peotry":["poetry"],
  "perade":["parade"],
  "percepted":["perceived"],
  "percieve":["perceive"],
  "percieved":["perceived"],
  "perfomance":["performance"],
  "performence":["performance"],
  "performes":["performed"],
  "perhasp":["perhaps"],
  "perheaps":["perhaps"],
  "perhpas":["perhaps"],
  "peripathetic":["peripatetic"],
  "peristent":["persistent"],
  "perjery":["perjury"],
  "perjorative":["pejorative"],
  "permanant":["permanent"],
  "permenant":["permanent"],
  "permissable":["permissible"],
  "perogative":["prerogative"],
  "peronal":["personal"],
  "perosnality":["personality"],
  "perphas":["perhaps"],
  "perpindicular":["perpendicular"],
  "persan":["person"],
  "perseverence":["perseverance"],
  "persistance":["persistence"],
  "persistant":["persistent"],
  "personel":["personnel", "personal"],
  "personell":["personnel"],
  "personnell":["personnel"],
  "persuded":["persuaded"],
  "persue":["pursue"],
  "persuit":["pursuit"],
  "pertubation":["perturbation"],
  "pessiary":["pessary"],
  "petetion":["petition"],
  "Pharoah":["Pharaoh"],
  "phenomenom":["phenomenon"],
  "phenomenonal":["phenomenal"],
  "phenomonenon":["phenomenon"],
  "phenomonon":["phenomenon"],
  "phenonmena":["phenomena"],
  "Philipines":["Philippines"],
  "philisopher":["philosopher"],
  "philisophical":["philosophical"],
  "philisophy":["philosophy"],
  "Phillipine":["Philippine"],
  "Phillipines":["Philippines"],
  "Phillippines":["Philippines"],
  "philospher":["philosopher"],
  "philosphy":["philosophy"],
  "phongraph":["phonograph"],
  "phylosophical":["philosophical"],
  "piblisher":["publisher"],
  "pich":["pitch"],
  "pilgrimmage":["pilgrimage"],
  "pinapple":["pineapple"],
  "pinnaple":["pineapple"],
  "plagarism":["plagiarism"],
  "planation":["plantation"],
  "planed":["planned"],
  "plantiff":["plaintiff"],
  "plateu":["plateau"],
  "plausable":["plausible"],
  "playright":["playwright"],
  "playwrite":["playwright"],
  "pleasent":["pleasant"],
  "plebicite":["plebiscite"],
  "plesant":["pleasant"],
  "poenis":["penis"],
  "poety":["poetry"],
  "poisin":["poison"],
  "polical":["political"],
  "polinator":["pollinator"],
  "politican":["politician"],
  "poltical":["political"],
  "polute":["pollute"],
  "poluted":["polluted"],
  "polution":["pollution"],
  "polyphonyic":["polyphonic"],
  "pomegranite":["pomegranate"],
  "poportional":["proportional"],
  "popoulation":["population"],
  "popularaty":["popularity"],
  "populare":["popular"],
  "populer":["popular"],
  "porshan":["portion"],
  "porshon":["portion"],
  "portait":["portrait"],
  "Portugese":["Portuguese"],
  "portugues":["Portuguese"],
  "posess":["possess"],
  "posession":["possession"],
  "posion":["poison"],
  "positon":["position", "positron"],
  "possable":["possible"],
  "possably":["possibly"],
  "possesion":["possession"],
  "possibile":["possible"],
  "possibilty":["possibility"],
  "possiblility":["possibility"],
  "possiblilty":["possibility"],
  "possiblity":["possibility"],
  "possition":["position"],
  "Postdam":["Potsdam"],
  "posthomous":["posthumous"],
  "postion":["position"],
  "postive":["positive"],
  "potatos":["potatoes"],
  "potrait":["portrait"],
  "poulations":["populations"],
  "poverful":["powerful"],
  "poweful":["powerful"],
  "powerfull":["powerful"],
  "ppublisher":["publisher"],
  "practial":["practical"],
  "practicioner":["practitioner"],
  "practioner":["practitioner"],
  "prairy":["prairie"],
  "prarie":["prairie"],
  "pratice":["practice"],
  "preample":["preamble"],
  "precedessor":["predecessor"],
  "preceed":["precede"],
  "precentage":["percentage"],
  "precice":["precise"],
  "precurser":["precursor"],
  "predicatble":["predictable"],
  "prefered":["preferred"],
  "prefering":["preferring"],
  "preferrably":["preferably"],
  "preiod":["period"],
  "preliferation":["proliferation"],
  "premeire":["premiere"],
  "preminence":["preeminence"],
  "premission":["permission"],
  "preocupation":["preoccupation"],
  "prepair":["prepare"],
  "prepartion":["preparation"],
  "prepatory":["preparatory"],
  "preperation":["preparation"],
  "preriod":["period"],
  "presedential":["presidential"],
  "presense":["presence"],
  "presidenital":["presidential"],
  "presidental":["presidential"],
  "presitgious":["prestigious"],
  "prespective":["perspective"],
  "prestigeous":["prestigious"],
  "prestigous":["prestigious"],
  "presumabely":["presumably"],
  "presumibly":["presumably"],
  "pretection":["protection"],
  "prevelant":["prevalent"],
  "preverse":["perverse"],
  "previvous":["previous"],
  "pricipal":["principal"],
  "priciple":["principle"],
  "priestood":["priesthood"],
  "primarly":["primarily"],
  "primative":["primitive"],
  "primordal":["primordial"],
  "principlaity":["principality"],
  "principaly":["principality"],
  "principial":["principal"],
  "prinicipal":["principal"],
  "privalege":["privilege"],
  "privelege":["privilege"],
  "priveleged":["privileged"],
  "privelige":["privilege"],
  "priveliged":["privileged"],
  "privilage":["privilege"],
  "priviledge":["privilege"],
  "privledge":["privilege"],
  "privte":["private"],
  "probabilaty":["probability"],
  "probablistic":["probabilistic"],
  "probablly":["probably"],
  "probalibity":["probability"],
  "probaly":["probably"],
  "probelm":["problem"],
  "proccess":["process"],
  "procede":["proceed", "precede"],
  "procedes":["proceeds"],
  "procedger":["procedure"],
  "proceding":["proceeding"],
  "proceedure":["procedure"],
  "proces":["process"],
  "processer":["processor"],
  "proclaimation":["proclamation"],
  "proclomation":["proclamation"],
  "profesion":["profession"],
  "profesor":["professor"],
  "professer":["professor"],
  "proffesed":["professed"],
  "proffesion":["profession"],
  "proffesional":["professional"],
  "proffesor":["professor"],
  "profilic":["prolific"],
  "progidy":["prodigy"],
  "programable":["programmable"],
  "progrom":["pogrom", "program"],
  "prohabition":["prohibition"],
  "prominance":["prominence"],
  "prominant":["prominent"],
  "promiscous":["promiscuous"],
  "pronomial":["pronominal"],
  "pronounciation":["pronunciation"],
  "proove":["prove"],
  "prooved":["proved"],
  "prophacy":["prophecy"],
  "propietary":["proprietary"],
  "propmted":["prompted"],
  "propoganda":["propaganda"],
  "propogate":["propagate"],
  "propogation":["propagation"],
  "propper":["proper"],
  "proprietory":["proprietary"],
  "protaganist":["protagonist"],
  "protocal":["protocol"],
  "protoganist":["protagonist"],
  "protruberance":["protuberance"],
  "provacative":["provocative"],
  "provded":["provided"],
  "provicial":["provincial"],
  "provinicial":["provincial"],
  "provisonal":["provisional"],
  "proximty":["proximity"],
  "pseudononymous":["pseudonymous"],
  "pseudonyn":["pseudonym"],
  "psuedo":["pseudo"],
  "psycology":["psychology"],
  "psyhic":["psychic"],
  "pubilsher":["publisher"],
  "pubisher":["publisher"],
  "publiaher":["publisher"],
  "publically":["publicly"],
  "publicaly":["publicly"],
  "publicher":["publisher"],
  "publihser":["publisher"],
  "publisehr":["publisher"],
  "publiser":["publisher"],
  "publisger":["publisher"],
  "publisheed":["published"],
  "publisherr":["publisher"],
  "publishher":["publisher"],
  "publishor":["publisher"],
  "publishre":["publisher"],
  "publissher":["publisher"],
  "publlisher":["publisher"],
  "publsiher":["publisher"],
  "publusher":["publisher"],
  "Pucini":["Puccini"],
  "pulisher":["publisher"],
  "pumkin":["pumpkin"],
  "puplisher":["publisher"],
  "puritannical":["puritanical"],
  "pursuade":["persuade"],
  "pursuaded":["persuaded"],
  "puting":["putting"],
  "pwoer":["power"],
  "pyscic":["psychic"],
  "qtuie":["quite", "quiet"],
  "quantaty":["quantity"],
  "quantitiy":["quantity"],
  "quarantaine":["quarantine"],
  "Queenland":["Queensland"],
  "questonable":["questionable"],
  "quinessential":["quintessential"],
  "quitted":["quit"],
  "quizes":["quizzes"],
  "qutie":["quite", "quiet"],
  "rabinnical":["rabbinical"],
  "racaus":["raucous"],
  "radiactive":["radioactive"],
  "radify":["ratify"],
  "reaccurring":["recurring"],
  "realsitic":["realistic"],
  "reccuring":["recurring"],
  "recepient":["recipient"],
  "recident":["resident"],
  "reciept":["receipt"],
  "recieve":["receive"],
  "reciever":["receiver"],
  "recipiant":["recipient"],
  "recivership":["receivership"],
  "recogize":["recognize"],
  "recompence":["recompense"],
  "reconaissance":["reconnaissance"],
  "reconcilation":["reconciliation"],
  "reconized":["recognized"],
  "reconnaisance":["reconnaissance"],
  "reconnaissence":["reconnaissance"],
  "recontructed":["reconstructed"],
  "recrational":["recreational"],
  "recuring":["recurring"],
  "recurrance":["recurrence"],
  "rediculous":["ridiculous"],
  "refect":["reflect"],
  "refedendum":["referendum"],
  "referal":["referral"],
  "referece":["reference"],
  "refered":["referred"],
  "referemce":["reference"],
  "referenece":["reference"],
  "referiang":["referring"],
  "refering":["referring"],
  "refernce":["reference"],
  "referrence":["reference"],
  "reffered":["referred"],
  "refference":["reference"],
  "reffering":["referring"],
  "refrence":["reference"],
  "refridgeration":["refrigeration"],
  "refridgerator":["refrigerator"],
  "refromist":["reformist"],
  "refusla":["refusal"],
  "regardes":["regards"],
  "regluar":["regular"],
  "regulaion":["regulation"],
  "rehersal":["rehearsal"],
  "reknown":["renown"],
  "rela":["real"],
  "relatiopnship":["relationship"],
  "releive":["relieve"],
  "releiver":["reliever"],
  "relevence":["relevance"],
  "relevent":["relevant"],
  "reliablity":["reliability"],
  "relient":["reliant"],
  "religeous":["religious"],
  "religous":["religious"],
  "relinqushment":["relinquishment"],
  "relized":["realized"],
  "remeber":["remember"],
  "rememberable":["memorable"],
  "rememberance":["remembrance"],
  "remembrence":["remembrance"],
  "remenant":["remnant"],
  "remenicent":["reminiscent"],
  "reminent":["remnant"],
  "reminescent":["reminiscent"],
  "reminscent":["reminiscent"],
  "reminsicent":["reminiscent"],
  "rendevous":["rendezvous"],
  "rendezous":["rendezvous"],
  "renewl":["renewal"],
  "rennovate":["renovate"],
  "rennovation":["renovation"],
  "reoccurrence":["recurrence"],
  "repatition":["repetition"],
  "repblic":["republic"],
  "repeition":["repetition"],
  "repentence":["repentance"],
  "repentent":["repentant"],
  "repetion":["repetition"],
  "repid":["rapid"],
  "reponse":["response"],
  "reponsible":["responsible"],
  "represantative":["representative"],
  "representive":["representative"],
  "reprtoire":["repertoire"],
  "reptition":["repetition"],
  "repubic":["republic"],
  "republi":["republic"],
  "repulic":["republic"],
  "requirment":["requirement"],
  "resaurant":["restaurant"],
  "resevoir":["reservoir"],
  "residental":["residential"],
  "resistable":["resistible"],
  "resistence":["resistance"],
  "resistent":["resistant"],
  "responce":["response"],
  "responisble":["responsible"],
  "responnsibilty":["responsibility"],
  "responsability":["responsibility"],
  "responsibile":["responsible"],
  "responsiblity":["responsibility"],
  "ressemble":["resemble"],
  "ressurect":["resurrect"],
  "ressurection":["resurrection"],
  "ressurrection":["resurrection"],
  "restarant":["restaurant"],
  "restaraunt":["restaurant"],
  "restaraunteur":["restaurateur"],
  "restauration":["restoration"],
  "restauraunt":["restaurant"],
  "resteraunt":["restaurant"],
  "resticted":["restricted"],
  "restraunt":["restraint", "restaurant"],
  "resturant":["restaurant"],
  "resturaunt":["restaurant"],
  "retalitation":["retaliation"],
  "retreive":["retrieve"],
  "reveral":["reversal"],
  "reversable":["reversible"],
  "revolutionar":["revolutionary"],
  "rewriet":["rewrite"],
  "rference":["reference"],
  "rhymme":["rhyme"],
  "rhythem":["rhythm"],
  "rhythim":["rhythm"],
  "rhytmic":["rhythmic"],
  "rigeur":["rigor"],
  "rigourous":["rigorous"],
  "rised":["rose"],
  "Rockerfeller":["Rockefeller"],
  "rococco":["rococo"],
  "roomate":["roommate"],
  "rucuperate":["recuperate"],
  "rudimentatry":["rudimentary"],
  "rulle":["rule"],
  "runing":["running"],
  "runnung":["running"],
  "russina":["Russian"],
  "Russion":["Russian"],
  "rwite":["write"],
  "rythem":["rhythm"],
  "rythim":["rhythm"],
  "rythm":["rhythm"],
  "rythmic":["rhythmic"],
  "sacrafice":["sacrifice"],
  "sacreligious":["sacrilegious"],
  "Sacremento":["Sacramento"],
  "sacrifical":["sacrificial"],
  "saftey":["safety"],
  "safty":["safety"],
  "salery":["salary"],
  "sandwhich":["sandwich"],
  "Sanhedrim":["Sanhedrin"],
  "santioned":["sanctioned"],
  "sargant":["sergeant"],
  "sargeant":["sergeant"],
  "sasy":["sassy"],
  "satelite":["satellite"],
  "Saterday":["Saturday"],
  "satisfactority":["satisfactorily"],
  "satric":["satiric"],
  "satrical":["satirical"],
  "sattelite":["satellite"],
  "saught":["sought"],
  "saveing":["saving"],
  "saxaphone":["saxophone"],
  "scandanavia":["Scandinavia"],
  "scaricity":["scarcity"],
  "schedual":["schedule"],
  "scholarhip":["scholarship"],
  "scholarstic":["scholastic"],
  "scientfic":["scientific"],
  "scientifc":["scientific"],
  "scientis":["scientist"],
  "scince":["science"],
  "scinece":["science"],
  "scirpt":["script"],
  "scoll":["scroll"],
  "screenwrighter":["screenwriter"],
  "scrutinity":["scrutiny"],
  "seach":["search"],
  "seceed":["succeed", "secede"],
  "secratary":["secretary"],
  "secretery":["secretary"],
  "sedereal":["sidereal"],
  "seeked":["sought"],
  "segementation":["segmentation"],
  "seige":["siege"],
  "seing":["seeing"],
  "seinor":["senior"],
  "seldomly":["seldom"],
  "sence":["sense", "since"],
  "senstive":["sensitive"],
  "sensure":["censure"],
  "seperate":["separate"],
  "seperation":["separation"],
  "seperatism":["separatism"],
  "seperatist":["separatist"],
  "sepina":["subpoena"],
  "sepulchure":["sepulcher"],
  "sepulcre":["sepulcher"],
  "sergent":["sergeant"],
  "settelement":["settlement"],
  "settlment":["settlement"],
  "severeal":["several"],
  "sevice":["service"],
  "shaddow":["shadow"],
  "shamen":["shaman"],
  "sheat":["sheath", "sheet", "cheat"],
  "sheild":["shield"],
  "sherif":["sheriff"],
  "shiped":["shipped"],
  "shiping":["shipping"],
  "shoudl":["should"],
  "shoudln":["should", "shouldn't"],
  "shreak":["shriek"],
  "shrinked":["shrunk"],
  "sicne":["since"],
  "sideral":["sidereal"],
  "sieze":["seize", "size"],
  "siezing":["sizing"],
  "siezure":["seizure"],
  "siginificant":["significant"],
  "signficant":["significant"],
  "signficiant":["significant"],
  "signifigant":["significant"],
  "signitory":["signatory"],
  "similiar":["similar"],
  "similiarity":["similarity"],
  "simmilar":["similar"],
  "simpley":["simply"],
  "simultanous":["simultaneous"],
  "singsog":["singsong"],
  "sinse":["since"],
  "Sionist":["Zionist"],
  "Sixtin":["Sistine"],
  "skateing":["skating"],
  "smae":["same"],
  "smoe":["some"],
  "snese":["sneeze"],
  "socalism":["socialism"],
  "soem":["some"],
  "sofware":["software"],
  "sohw":["show"],
  "solatary":["solitary"],
  "soley":["solely"],
  "soliliquy":["soliloquy"],
  "soluable":["soluble"],
  "somene":["someone"],
  "somwhere":["somewhere"],
  "sophicated":["sophisticated"],
  "sophmore":["sophomore"],
  "sorceror":["sorcerer"],
  "sorrounding":["surrounding"],
  "sotry":["story"],
  "sotyr":["satyr", "story"],
  "soudn":["sound"],
  "sould":["could", "should", "sold", "soul"],
  "sountrack":["soundtrack"],
  "sourth":["south"],
  "sourthern":["southern"],
  "souvenier":["souvenir"],
  "sovereignity":["sovereignty"],
  "soverign":["sovereign"],
  "soverignity":["sovereignty"],
  "soverignty":["sovereignty"],
  "spainish":["Spanish"],
  "speach":["speech"],
  "specfic":["specific"],
  "speciman":["specimen"],
  "spectauclar":["spectacular"],
  "spectum":["spectrum"],
  "speices":["species"],
  "spermatozoan":["spermatozoon"],
  "spoace":["space"],
  "sponser":["sponsor"],
  "spontanous":["spontaneous"],
  "spreaded":["spread"],
  "sprech":["speech"],
  "spred":["spread"],
  "spriritual":["spiritual"],
  "spritual":["spiritual"],
  "sqaure":["square"],
  "stablility":["stability"],
  "stainlees":["stainless"],
  "staion":["station"],
  "stange":["strange"],
  "startegic":["strategic"],
  "startegy":["strategy"],
  "stateman":["statesman"],
  "statment":["statement"],
  "stilus":["stylus"],
  "stingent":["stringent"],
  "stiring":["stirring"],
  "stlye":["style"],
  "stomache":["stomach"],
  "stong":["strong"],
  "stopry":["story"],
  "stoyr":["story"],
  "stpo":["stop"],
  "stradegy":["strategy"],
  "strat":["start", "strata"],
  "stregth":["strength"],
  "strenghen":["strengthen"],
  "strenght":["strength"],
  "strenghten":["strengthen"],
  "strenous":["strenuous"],
  "strnad":["strand"],
  "stroy":["story", "destroy"],
  "structual":["structural"],
  "stubborness":["stubbornness"],
  "stucture":["structure"],
  "stuctured":["structured"],
  "studdy":["study"],
  "sturcture":["structure"],
  "subcatagory":["subcategory"],
  "subjudgation":["subjugation"],
  "subpecies":["subspecies"],
  "subsidary":["subsidiary"],
  "subsiduary":["subsidiary"],
  "subsquent":["subsequent"],
  "substace":["substance"],
  "substancial":["substantial"],
  "substatial":["substantial"],
  "substract":["subtract"],
  "substraction":["subtraction"],
  "subterranian":["subterranean"],
  "suburburban":["suburban"],
  "succesful":["successful"],
  "succesion":["succession"],
  "succesive":["successive"],
  "successfull":["successful"],
  "succsess":["success"],
  "succsessfull":["successful"],
  "suceed":["succeed"],
  "sucesful":["successful"],
  "sucesion":["succession"],
  "sucess":["success"],
  "sucessful":["successful"],
  "sucessfull":["successful"],
  "sucession":["succession"],
  "sucessive":["successive"],
  "sucessor":["successor"],
  "sucessot":["successor"],
  "sucide":["suicide"],
  "sucidial":["suicidal"],
  "sufferage":["suffrage"],
  "sufferring":["suffering"],
  "sufficent":["sufficient"],
  "sumary":["summary"],
  "sunglases":["sunglasses"],
  "suop":["soup"],
  "superintendant":["superintendent"],
  "suphisticated":["sophisticated"],
  "supose":["suppose"],
  "suposed":["supposed"],
  "suppoed":["supposed"],
  "suppy":["supply"],
  "supress":["suppress"],
  "suprise":["surprise"],
  "suprising":["surprising"],
  "suprize":["surprise"],
  "suprizing":["surprising"],
  "surfce":["surface"],
  "surley":["surly"],
  "suround":["surround"],
  "surounding":["surrounding"],
  "suroundings":["surroundings"],
  "surpress":["suppress"],
  "surprize":["surprise"],
  "surprizing":["surprising"],
  "surrepetitious":["surreptitious"],
  "surreptious":["surreptitious"],
  "surrouding":["surrounding"],
  "surveilence":["surveillance"],
  "surveyer":["surveyor"],
  "surviver":["survivor"],
  "suseptable":["susceptible"],
  "suseptible":["susceptible"],
  "suspention":["suspension"],
  "swaer":["swear"],
  "swepth":["swept"],
  "swiming":["swimming"],
  "symetrical":["symmetrical"],
  "symetry":["symmetry"],
  "symettric":["symmetric"],
  "symmetral":["symmetric"],
  "synagouge":["synagogue"],
  "syncronization":["synchronization"],
  "synonomous":["synonymous"],
  "synphony":["symphony"],
  "syphyllis":["syphilis"],
  "syrap":["syrup"],
  "sytem":["system"],
  "sytle":["style"],
  "tabacco":["tobacco"],
  "tahn":["than"],
  "taht":["that"],
  "tast":["taste"],
  "tath":["that"],
  "tatoo":["tattoo"],
  "taxanomic":["taxonomic"],
  "taxanomy":["taxonomy"],
  "teached":["taught"],
  "techician":["technician"],
  "technitian":["technician"],
  "technnology":["technology"],
  "technolgy":["technology"],
  "teh":["the"],
  "tehy":["they"],
  "telelevision":["television"],
  "televsion":["television"],
  "telphony":["telephony"],
  "temerature":["temperature"],
  "tempalte":["template"],
  "temparate":["temperate"],
  "temperarily":["temporarily"],
  "temperment":["temperament"],
  "tempertaure":["temperature"],
  "temperture":["temperature"],
  "temprary":["temporary"],
  "tenacle":["tentacle"],
  "tendacy":["tendency"],
  "tendancy":["tendency"],
  "tepmorarily":["temporarily"],
  "terrestial":["terrestrial"],
  "terriory":["territory"],
  "territorist":["terrorist"],
  "territoy":["territory"],
  "terroist":["terrorist"],
  "testiclular":["testicular"],
  "testomony":["testimony"],
  "tghe":["the"],
  "thast":["that"],
  "theather":["theater"],
  "theese":["these"],
  "theif":["thief"],
  "themselfs":["themselves"],
  "themslves":["themselves"],
  "ther":["there", "their", "the"],
  "therafter":["thereafter"],
  "therby":["thereby"],
  "theri":["their"],
  "theyre":["they're"],
  "thgat":["that"],
  "thge":["the"],
  "thier":["their"],
  "thign":["thing"],
  "thikn":["think"],
  "thikning":["thickening"],
  "thiunk":["think"],
  "thn":["then"],
  "thna":["than"],
  "thne":["then"],
  "thnig":["thing"],
  "thoughout":["throughout"],
  "threatning":["threatening"],
  "threee":["three"],
  "threshhold":["threshold"],
  "thrid":["third"],
  "throrough":["thorough"],
  "throught":["thought", "through", "throughout"],
  "througout":["throughout"],
  "thsi":["this"],
  "thsoe":["those"],
  "thta":["that"],
  "thyat":["that"],
  "tiem":["time", "Tim"],
  "tihkn":["think"],
  "tihs":["this"],
  "timne":["time"],
  "tiome":["time", "tome"],
  "tje":["the"],
  "tjhe":["the"],
  "tkae":["take"],
  "tkaing":["taking"],
  "tobbaco":["tobacco"],
  "todya":["today"],
  "toghether":["together"],
  "tolerence":["tolerance"],
  "Tolkein":["Tolkien"],
  "tomatos":["tomatoes"],
  "tommorow":["tomorrow"],
  "tommorrow":["tomorrow"],
  "tongiht":["tonight"],
  "tornadoe":["tornado"],
  "torpeados":["torpedoes"],
  "torpedos":["torpedoes"],
  "tounge":["tongue"],
  "tourch":["torch", "touch"],
  "towrad":["toward"],
  "traditionnal":["traditional"],
  "traditition":["tradition"],
  "trafficed":["trafficked"],
  "trafficing":["trafficking"],
  "trafic":["traffic"],
  "trancendent":["transcendent"],
  "tranform":["transform"],
  "transcendance":["transcendence"],
  "transcendant":["transcendent"],
  "transcendentational":["transcendental"],
  "transcripting":["transcription"],
  "transfered":["transferred"],
  "transfering":["transferring"],
  "transformaton":["transformation"],
  "transistion":["transition"],
  "translater":["translator"],
  "transmissable":["transmissible"],
  "transporation":["transportation"],
  "tremelo":["tremolo"],
  "triology":["trilogy"],
  "troup":["troupe"],
  "truely":["truly"],
  "trustworthyness":["trustworthiness"],
  "turnk":["turnkey", "trunk"],
  "tust":["trust"],
  "twelth":["twelfth"],
  "twon":["town"],
  "twpo":["two"],
  "tyhat":["that"],
  "tyhe":["they"],
  "typcial":["typical"],
  "tyrany":["tyranny"],
  "tyrrany":["tyranny"],
  "ubiquitious":["ubiquitous"],
  "ublisher":["publisher"],
  "uise":["use"],
  "Ukranian":["Ukrainian"],
  "unahppy":["unhappy"],
  "unanymous":["unanimous"],
  "unbeknowst":["unbeknownst"],
  "unchangable":["unchangeable"],
  "unconcious":["unconscious"],
  "uncontitutional":["unconstitutional"],
  "understoon":["understood"],
  "undesireable":["undesirable"],
  "undreground":["underground"],
  "uneccesary":["unnecessary"],
  "unecessary":["unnecessary"],
  "unilatreal":["unilateral"],
  "uninterruped":["uninterrupted"],
  "uninterupted":["uninterrupted"],
  "univeral":["universal"],
  "univeristy":["university"],
  "univerity":["university"],
  "universtiy":["university"],
  "univesity":["university"],
  "unkown":["unknown"],
  "unlikey":["unlikely"],
  "unmistakeably":["unmistakably"],
  "unneccesary":["unnecessary"],
  "unneccessary":["unnecessary"],
  "unnecesary":["unnecessary"],
  "unoffical":["unofficial"],
  "unoperational":["nonoperational"],
  "unprecendented":["unprecedented"],
  "unprecidented":["unprecedented"],
  "unrepentent":["unrepentant"],
  "unrepetant":["unrepentant"],
  "unrepetent":["unrepentant"],
  "unsed":["used"],
  "untill":["until"],
  "unviersity":["university"],
  "unweildly":["unwieldy"],
  "unwieldly":["unwieldy"],
  "upcomming":["upcoming"],
  "useage":["usage"],
  "usefull":["useful"],
  "vaccum":["vacuum"],
  "vaccume":["vacuum"],
  "vacinity":["vicinity"],
  "vailidty":["validity"],
  "valuble":["valuable"],
  "valueable":["valuable"],
  "varient":["variant"],
  "variey":["variety"],
  "varing":["varying"],
  "varity":["variety"],
  "vasall":["vassal"],
  "vegatarian":["vegetarian"],
  "vegitable":["vegetable"],
  "vegtable":["vegetable"],
  "vehicule":["vehicle"],
  "vell":["well"],
  "venemous":["venomous"],
  "vengance":["vengeance"],
  "vengence":["vengeance"],
  "verfication":["verification"],
  "verison":["version"],
  "vermillion":["vermilion"],
  "versitilaty":["versatility"],
  "versitlity":["versatility"],
  "vetween":["between"],
  "veyr":["very"],
  "vigeur":["vigor"],
  "vigilence":["vigilance"],
  "vigourous":["vigorous"],
  "villian":["villain"],
  "villification":["vilification"],
  "villify":["vilify"],
  "villin":["villi", "villain", "villein"],
  "vincinity":["vicinity"],
  "violentce":["violence"],
  "virutal":["virtual"],
  "visable":["visible"],
  "visably":["visibly"],
  "volcanoe":["volcano"],
  "voleyball":["volleyball"],
  "volontary":["voluntary"],
  "volonteer":["volunteer"],
  "volounteer":["volunteer"],
  "volumne":["volume"],
  "vreity":["variety"],
  "vrey":["very"],
  "vriety":["variety"],
  "vulnerablility":["vulnerability"],
  "vyer":["very"],
  "vyre":["very"],
  "waht":["what"],
  "warantee":["warranty"],
  "wardobe":["wardrobe"],
  "warrent":["warrant"],
  "wasnt":["wasn't"],
  "wass":["was"],
  "watn":["want"],
  "wayword":["wayward"],
  "weaponary":["weaponry"],
  "weas":["was"],
  "wehn":["when"],
  "weild":["wield", "wild"],
  "wendsay":["Wednesday"],
  "wensday":["Wednesday"],
  "wereabouts":["whereabouts"],
  "whant":["want"],
  "whcih":["which"],
  "wheras":["whereas"],
  "wherease":["whereas"],
  "whereever":["wherever"],
  "whic":["which"],
  "whihc":["which"],
  "whith":["with"],
  "whlch":["which"],
  "whn":["when"],
  "wholey":["wholly"],
  "wholy":["wholly", "holy"],
  "whta":["what"],
  "whther":["whether"],
  "wich":["which", "witch"],
  "widesread":["widespread"],
  "wief":["wife"],
  "wierd":["weird"],
  "wiew":["view"],
  "wih":["with"],
  "wiht":["with"],
  "wille":["will"],
  "willk":["will"],
  "willingless":["willingness"],
  "wirting":["writing"],
  "withdrawl":["withdrawal", "withdraw"],
  "witheld":["withheld"],
  "withh":["with"],
  "withing":["within"],
  "withold":["withhold"],
  "witht":["with"],
  "witn":["with"],
  "wiull":["will"],
  "wnat":["want"],
  "wnated":["wanted"],
  "wohle":["whole"],
  "wokr":["work"],
  "wonderfull":["wonderful"],
  "wordlwide":["worldwide"],
  "workststion":["workstation"],
  "worls":["world"],
  "woudl":["would"],
  "wriet":["write"],
  "writen":["written"],
  "wroet":["wrote"],
  "wrok":["work"],
  "wtih":["with"],
  "wupport":["support"],
  "xenophoby":["xenophobia"],
  "yaching":["yachting"],
  "yaer":["year"],
  "yaerly":["yearly"],
  "yatch":["yacht"],
  "yearm":["year"],
  "yeild":["yield"],
  "Yementite":["Yemenite", "Yemeni"],
  "yera":["year"],
  "yrea":["year"],
  "youself":["yourself"],
  "ytou":["you"],
  "yuo":["you"],
  "yo":["you"],
  "zeebra":["zebra"]
}